var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',[_c('strong',[_vm._v("Copyright")]),_vm._v(" Delivery Monsters © 2020-2025\n    ")])])}]

export { render, staticRenderFns }